import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import { api_url } from "../../../js_assets/ConfigApp";

import Dialog from "@material-ui/core/Dialog";
import { getParameterByName } from "../../../js_assets/getParameterByName";

import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";
import AppAdminContainer from "../AppAdminContainer";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";

import CircularProgress from "@material-ui/core/CircularProgress";
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  input: {
    paddingRight: 10,
    flex: 1,
  },
  divpadding: {
    padding: "5%",
  },
  btn_login: {
    color: "white",
    padding: "10px 1px",
    border: "none",
    cursor: "pointer",
    width: "100%",
    opacity: "0.9",
    borderRadius: "3px",
  },
  btn_Resetfrom: {
    color: "white",
  },
});

class TrainerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Schedule_Package_Type_Data: [],
      loading_Save: false,
      trainer_Id: 0,
      trainer_Image: null,
      trainer_Document: null,
      successmessage: false,
    };
  }

  componentDidMount() {
    let TrainerID = getParameterByName("TrainerID");

    if (TrainerID !== null) {
      if (TrainerID === "New") {
        //console.log("it new ")
      } else {
        //console.log("it number " + TrainerID)

        axios
          .get(`${api_url}/api/trainer/GetTrainer/${TrainerID}`)
          .then((result) => {
            //console.log(result.data);

            this.setState({ trainer_Id: result.data.trainer_Id });
            this.refs.trainer_Name.value = result.data.trainer_Name;
            this.refs.trainer_Phone.value = result.data.trainer_Phone;
            this.refs.trainer_Email.value = result.data.trainer_Email;
            this.refs.trainer_Specialty.value = result.data.trainer_Specialty;
            this.refs.trainer_Describe.value = result.data.trainer_Describe;
            this.refs.trainer_Location.value = result.data.trainer_Location;
            this.setState({ trainer_Image: result.data.trainer_Image });
            this.refs.score_Value.value = result.data.score_Value;
            this.refs.trainer_Protein_Tag.value =
              result.data.trainer_Protein_Tag;
            this.setState({ trainer_Document: result.data.trainer_Document });
          });
      }
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  Save_Health_Trainer = (e) => {
    e.preventDefault();
    this.setState({ loading_Save: true });
    var data = new FormData();

    if (this.refs.ImageUP.files.length !== 0) {
      data.append("UploadedImage", this.refs.ImageUP.files[0]);

      axios
        .post(`${api_url}/api/trainer/SaveImageTrainer`, data, {
          headers: { "Content-type": "application/json; charset=utf-8" },
        })
        .then((result) => {
          let TrainerData = {
            trainer_Id: parseInt(this.refs.trainer_Id.value),
            trainer_Name: this.refs.trainer_Name.value,
            trainer_Phone: this.refs.trainer_Phone.value,
            trainer_Email: this.refs.trainer_Email.value,
            trainer_Specialty: this.refs.trainer_Specialty.value,
            trainer_Describe: this.refs.trainer_Describe.value,
            trainer_Location: this.refs.trainer_Location.value,
            score_Value: parseInt(this.refs.score_Value.value),
            trainer_Image: result.data,
            trainer_Protein_Tag:
              this.refs.trainer_Protein_Tag.value === "true" ? true : false,
            trainer_Document: this.state.trainer_Document,
          };

          axios
            .post(
              `${api_url}/api/trainer/SaveTrainer`,
              JSON.stringify(TrainerData),
              { headers: { "Content-type": "application/json; charset=utf-8" } }
            )
            .then(() => {
              this.setState({ loading_Save: false, successmessage: true });
              //console.log("it update ")
            });
        });
    } else if (this.refs.DocumentUP.files.length !== 0) {
      data.append("UploadedImage", this.refs.DocumentUP.files[0]);

      axios
        .post(`${api_url}/api/trainer/SaveImageTrainer`, data, {
          headers: { "Content-type": "application/json; charset=utf-8" },
        })
        .then((result) => {
          let TrainerData = {
            trainer_Id: parseInt(this.refs.trainer_Id.value),
            trainer_Name: this.refs.trainer_Name.value,
            trainer_Phone: this.refs.trainer_Phone.value,
            trainer_Email: this.refs.trainer_Email.value,
            trainer_Specialty: this.refs.trainer_Specialty.value,
            trainer_Describe: this.refs.trainer_Describe.value,
            trainer_Location: this.refs.trainer_Location.value,
            score_Value: parseInt(this.refs.score_Value.value),
            trainer_Image: this.state.trainer_Image,
            trainer_Protein_Tag:
              this.refs.trainer_Protein_Tag.value === "true" ? true : false,
            trainer_Document: result.data,
          };

          axios
            .post(
              `${api_url}/api/trainer/SaveTrainer`,
              JSON.stringify(TrainerData),
              { headers: { "Content-type": "application/json; charset=utf-8" } }
            )
            .then(() => {
              this.setState({ loading_Save: false, successmessage: true });
              //console.log("it update ")
            });
        });
    } else {
      let TrainerData = {
        trainer_Id: parseInt(this.refs.trainer_Id.value),
        trainer_Name: this.refs.trainer_Name.value,
        trainer_Phone: this.refs.trainer_Phone.value,
        trainer_Email: this.refs.trainer_Email.value,
        trainer_Specialty: this.refs.trainer_Specialty.value,
        trainer_Describe: this.refs.trainer_Describe.value,
        trainer_Location: this.refs.trainer_Location.value,
        score_Value: parseInt(this.refs.score_Value.value),
        trainer_Image: this.state.trainer_Image,
        trainer_Protein_Tag:
          this.refs.trainer_Protein_Tag.value === "true" ? true : false,
        trainer_Document: this.state.trainer_Document,
      };

      axios
        .post(
          `${api_url}/api/trainer/SaveTrainer`,
          JSON.stringify(TrainerData),
          { headers: { "Content-type": "application/json; charset=utf-8" } }
        )
        .then(() => {
          this.setState({ loading_Save: false, successmessage: true });
        });
    }
  };

  handlClosesuccessmessage = () => {
    this.setState({ successmessage: false });
  };

  render() {
    const { classes } = this.props;
    const { loading_Save } = this.state;

    return (
      <AppAdminContainer Title={"المدرب"}>
        <div className="container">
          <Dialog
            open={this.state.successmessage}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handlClosesuccessmessage}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              <div className="alertIcon">
                ✔️ <label>تم حفظ </label>
              </div>
            </DialogTitle>
          </Dialog>

          <form
            //
            onSubmit={this.Save_Health_Trainer}
            acceptCharset={"multipart/form-data"}
          >
            <Grid justify="center" alignItems="center" container spacing={8}>
              <img
                className="w3-circle"
                src={`${api_url}/Content/Profile_Images/${this.state.trainer_Image}`}
              ></img>
              <br />
            </Grid>

            <Grid justify="center" alignItems="center" container spacing={8}>
              {this.state.trainer_Document != null && (
                <a
                  href={`${api_url}/Content/Profile_Images/${this.state.trainer_Document}`}
                  target="_self"
                  download="newfilename"
                >
                  مشاهدة المستند
                </a>
              )}
            </Grid>

            <input ref="trainer_Id" value={this.state.trainer_Id} />
            <br></br>

            <span> الاسم</span>
            <div >
              <input

                placeholder="الاسم "
                name="trainer_Name"
                ref="trainer_Name"
                required
              />
            </div>

            <span>رقم الجوال</span>
            <div >
              <input

                placeholder="رقم الجوال"
                name="trainer_Phone"
                ref="trainer_Phone"
                maxLength="10"
                minLength="10"
                pattern="[0-9]*"
                title="يجب انك تكون 10 رقم"
                required
              />
            </div>
            <span>البريد الاكتروني</span>
            <div >
              <input

                placeholder="البريد الاكتروني"
                name="trainer_Email"
                ref="trainer_Email"
                required
              />
            </div>
            <span>التخصص</span>
            <div >
              <input

                placeholder="التخصص"
                name="trainer_Specialty"
                ref="trainer_Specialty"
                required
              />
            </div>

            <span> المنطقة</span>
            <div >
              <input

                placeholder="المنطقة"
                name="trainer_Location"
                ref="trainer_Location"
                required
              />
            </div>
            <span> قيمة الاستشارة</span>
            <div >
              <input

                placeholder="قيمة الاستشارة"
                name="score_Value"
                ref="score_Value"
                required
              />
            </div>

            <span> وسم بروتين للتميز </span>
            <div >
              <select
                ref="trainer_Protein_Tag"

                name="trainer_Protein_Tag"
              >
                <option value={false}>لا</option>
                <option value={true}>نعم</option>
              </select>
            </div>
            <span> نبذه عن المدرب </span>
            <div >
              <textarea
                rows={7}

                placeholder="نبذه عن المدرب"
                name="trainer_Describe"
                ref="trainer_Describe"
                required
              />
            </div>
            <label>صورة </label>
            <input
              type="file"
              ref="ImageUP"
              accept="image/*"
              name="fileInput"
            />
            <br />
            <br />

            <label>مستند المدرب /CV </label>
            <input
              type="file"
              ref="DocumentUP"
              accept="application/pdf"
              name="fileInput"
            />
            <div >
              <button
                variant="contained"
                type="Submit"
                color="primary"
                className={classes.btn_login}
              >
                {loading_Save === true ? (
                  <CircularProgress color={"secondary"} />
                ) : (
                  <label>حفظ</label>
                )}
              </button>
            </div>
          </form>
        </div>
      </AppAdminContainer>
    );
  }
}
TrainerProfile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TrainerProfile);
